var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.isProcessing)?_c('div',{staticClass:"home"},[_c('cards')],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }